import { useLocation, useParams } from 'react-router-dom';

// splices the shopId in/out of the url - works where our url is in the expected format /domain/[:shopId]/subpath
export const spliceUrl = (path, newId) => {
	const [paths, query] = path.split('?');
	const splitPath = paths.split('/');
	if (newId) splitPath.splice(2, 0, newId);
	path = splitPath.join('/');
	if (query) {
		path = path + '?' + query;
	}

	return path;
};

// Swaps the shopId in and out of the url to navigate between shops & organisation level
export const useSwapId = () => {
	const { pathname: currentLocation } = useLocation();
	const { shopId: currentId } = useParams();

	return (newId) => {
		let path = currentLocation;
		// going from error states
		if (path.includes('/404')) {
			path = '/home';
		}

		// going from org level...
		if (!currentId) {
			// ...to org level - no-need, this logic is taken care of in OrganisationSelector

			// ...to single shop
			if (typeof path === 'string') {
				path = spliceUrl(path, newId);
			}
		}

		// going from single shop level...
		if (currentId) {
			// ...to org
			if (!newId) {
				path = path.replace('/' + currentId, '');
			}
			// ...to a different single shop
			else {
				path = path.replace(currentId, newId);
			}
		}
		return path;
	};
};
